import type { FaireProductEntity } from "../../entity_types/product";

export const p_3rjp3yee4u: FaireProductEntity = {
  token: "p_3rjp3yee4u",
  type: "product",
  name: "Easily Distracted By Boobs Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/f3583e943cb81780eb1f2bc190b5570194079e17cda26897bad3721b93c2ba2a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cfe25176e598622e615ceef299fd28fdd32bea66619a9e7b74121fc2167d99a6.jpeg",
    "https://cdn.faire.com/fastly/12ae9d515041b64314300fbacc3ad9dcb335019389a43c3311fe13a6a05c6d06.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/708cecc32b9be324f57eb0f157bc4219cd30e37ff17dcad211733c64f7d395e5.jpeg",
    "https://cdn.faire.com/fastly/54beee5245b243ab15b31b71eed64a8a6592b7be9010b987ee2b78fbaee60380.jpeg"
  ],
  priceDollars: 6.75,
  description: "Warning: these socks may cause frequent glances down. 👀\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:17.287Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
